<template>
  <v-container
    fluid
    data-cy="recent-activity-container"
  >
    <v-row no-gutters>
      <v-col class="d-flex justify-start">
        <div class="rounded-circle illustration-container mr-4">
          <sn-illustration
            illustration="DemographicInfo"
            size="xs"
          />
        </div>
        <div class="d-flex justify-center align-start flex-column">
          <h2
            class="sn-h3 pb-2"
            data-cy="recent-activity-title"
          >
            Recent activity
          </h2>
          <p
            class="sn-body-1 pt-2 mb-0"
            data-cy="recent-activity-subtitle"
          >
            Last 30 days
          </p>
        </div>
      </v-col>
    </v-row>
    <sn-table-deprecated
      class="mt-8"
      :headers="headers"
      :items="authenticationAttempts"
    />
  </v-container>
</template>

<script>
import snClosingPortalService from '~/services/snClosingPortalService.js'

export default {
  name: 'RecentActivity',

  data () {
    return {
      authenticationAttempts: []
    }
  },

  computed: {
    headers () {
      return [
        { text: 'Time stamp', value: 'created_at', sortable: false, width: '25%', align: 'start' },
        { text: 'Location', value: 'location', sortable: false, width: '25%', align: 'start' },
        { text: 'IP Address', value: 'ip', sortable: false, width: '25%', align: 'start' },
        { text: 'Sign-in status', value: 'current_state', sortable: false, width: '25%', align: 'start' }
      ]
    }
  },

  created () {
    // Load recent activity.
    snClosingPortalService.getAuthenticationAttempts().then(resp => {
      this.authenticationAttempts = resp.data.authentication_attempts_user.map(aa => {
        let location = 'No Data'
        if (aa.location.city !== '' && aa.location.state !== '') {
          location = `${aa.location.city}, ${aa.location.state}`
        }
        let currentState = ''
        if (aa.current_state === 'auth_signed_in') {
          currentState = 'Successful'
        } else {
          currentState = 'Unsuccessful'
        }
        return {
          created_at: this.$options.filters.formatDateTime(aa.created_at),
          location: location,
          ip: aa.location.ip !== null ? aa.location.ip : 'No Data',
          current_state: currentState
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.illustration-container {
  background-color: $sn-brand-01;
  width: 112px;
  height: 112px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
